import Color from "@arcgis/core/Color.js";
import SimpleFillSymbol from "@arcgis/core/symbols/SimpleFillSymbol.js";
import SimpleLineSymbol from "@arcgis/core/symbols/SimpleLineSymbol.js";
import TextSymbol from "@arcgis/core/symbols/TextSymbol.js";

export const polygonSymbol = () => {
    return new SimpleFillSymbol({
        color: new Color([248, 221, 183, 1]),
        outline: new SimpleLineSymbol({
            cap: "round",
            color: new Color([242, 153, 57, 0.75]),
            join: "round",
            miterLimit: 1,
            style: "solid",
            width: 5
        }),
        style: "none"
    });
}

export const textSymbol = (text: string) => {
    return new TextSymbol({
        text: text,
        color: "black",
        haloColor: new Color([255, 255, 255, 1]),
        haloSize: 1,
        backgroundColor: [255, 252, 250, 0],
        borderLineColor: [153, 148, 144, 0],
        borderLineSize: undefined,
        yoffset: 5,
        font: {
            size: 14,
            family: "Inter"
        }
    });
}